import _defineProperty from "/var/www/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/var/www/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import ClearIcon from '@mui/icons-material/Clear';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { getVideoId, getHashParameter } from 'helpers';
import { IconButton, InputAdornment, Button } from '@mui/material';
import TextField from '@atoms/TextField';
import { useTranslation } from '../../../../config/i18n';
import { VideoContainer, CloseBtn, useClasses } from './style';
import Image from '../../../atoms/Image';

// const getHeight = (width) => (width * 45) / 80;
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var VideoItem = function VideoItem(_ref) {
  var onChange = _ref.onChange,
    index = _ref.index,
    value = _ref.value,
    onRemoveClick = _ref.onRemoveClick,
    width = _ref.width,
    height = _ref.height,
    onLinkAdded = _ref.onLinkAdded,
    onedit = _ref.onedit;
  var _useTranslation = useTranslation(['applications', 'common', 'opportunity']),
    t = _useTranslation.t;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    localVal = _React$useState2[0],
    setLocalVal = _React$useState2[1];
  var classes = useClasses();
  var onChangeHandler = function onChangeHandler(e) {
    var link = e.target.value;
    var parsedLink = link;
    if (/^(?:[\w-]+\.)+[\w-]+(?:\/.*)?$/.test(link) && !/^https?:\/\//i.test(link)) {
      parsedLink = "http://".concat(link);
    }
    var videoId = getVideoId(parsedLink);
    if (videoId) {
      onChange(parsedLink, index);
      setLocalVal(false);
    } else {
      setLocalVal(true);
    }
    onLinkAdded();
  };
  var handleMouseDownRemove = function handleMouseDownRemove(event) {
    event.preventDefault();
  };
  var removeClickHandler = function removeClickHandler() {
    onRemoveClick(index);
    onLinkAdded();
  };
  var parsedValue = null;
  var parsedLink = value;
  if (value) {
    if (/^(?:[\w-]+\.)+[\w-]+(?:\/.*)?$/.test(value) && !/^https?:\/\//i.test(value)) {
      parsedLink = "http://".concat(value);
    }
    var videoId = getVideoId(parsedLink);
    if (videoId && videoId.type === 'YOUTUBE') {
      parsedValue = /*#__PURE__*/_jsx("iframe", {
        className: classes.video,
        title: videoId.value,
        width: width,
        height: height,
        src: "https://www.youtube.com/embed/".concat(videoId.value),
        frameBorder: "0",
        allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
        allowFullScreen: true
      });
    } else if (videoId && videoId.type === 'VIMEO') {
      var hashParameter = getHashParameter(parsedLink);
      parsedValue = /*#__PURE__*/_jsx("iframe", {
        className: classes.video,
        title: videoId.value,
        src: "https://player.vimeo.com/video/".concat(videoId.value, "?h=").concat(hashParameter),
        width: width,
        height: height,
        frameBorder: "0",
        allow: "autoplay; fullscreen; picture-in-picture",
        allowFullScreen: true
      });
    } else if (videoId && videoId.type === 'LOOM') {
      parsedValue = /*#__PURE__*/_jsx("iframe", {
        className: classes.video,
        title: videoId.value,
        width: width,
        height: height,
        src: "https://www.loom.com/embed/".concat(videoId.value),
        frameBorder: "0",
        allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
        allowFullScreen: true
      });
    } else if (videoId && videoId.type === 'GENERIC') {
      parsedValue = /*#__PURE__*/_jsxs("div", {
        style: {
          position: 'relative'
        },
        children: [/*#__PURE__*/_jsx("iframe", {
          className: classes.video,
          title: videoId.value,
          width: width,
          height: height,
          src: videoId.value,
          frameBorder: "0",
          allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
          allowFullScreen: true
        }), /*#__PURE__*/_jsx(Button, {
          variant: "contained",
          color: "primary",
          startIcon: /*#__PURE__*/_jsx(OpenInNewIcon, {}),
          onClick: function onClick() {
            return window.open(videoId.value, '_blank');
          },
          style: {
            position: 'absolute',
            bottom: '10px',
            right: '10px'
          },
          children: "Open in New Tab"
        })]
      });
    } else {
      parsedValue = /*#__PURE__*/_jsx("iframe", {
        className: classes.video,
        title: "video",
        width: width,
        height: height,
        src: parsedLink,
        frameBorder: "0",
        allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
        allowFullScreen: true
      });
    }
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(VideoContainer, {
      fullWidth: !parsedValue,
      className: "video-item",
      children: [parsedValue || /*#__PURE__*/_jsx(TextField, _objectSpread(_objectSpread({
        className: "video-input",
        label: t('opportunity:link_to_video')
      }, localVal && {
        helperText: t('couldnot_extract_video'),
        error: true
      }), {}, {
        onChange: onChangeHandler,
        placeholder: "Link to video"
        // value={localVal}
        // error={Boolean(value && !parsedValue)}
        ,
        InputProps: {
          endAdornment: /*#__PURE__*/_jsx(InputAdornment, {
            position: "end",
            children: /*#__PURE__*/_jsx(IconButton, {
              "aria-label": "remove video item",
              onClick: removeClickHandler,
              onMouseDown: handleMouseDownRemove,
              edge: "end",
              children: /*#__PURE__*/_jsx(ClearIcon, {})
            })
          }),
          startAdornment: /*#__PURE__*/_jsx(InputAdornment, {
            position: "start",
            children: /*#__PURE__*/_jsx(Image, {
              src: "/images/icons/add_video.svg",
              width: "24px",
              height: "24px",
              color: "secondary"
            })
          })
        }
      })), onedit && onRemoveClick && parsedValue && /*#__PURE__*/_jsx(CloseBtn, {
        size: "small",
        color: "primary",
        "aria-label": "Remove",
        onClick: removeClickHandler,
        children: /*#__PURE__*/_jsx(ClearIcon, {})
      })]
    })
  });
};
VideoItem.defaultProps = {
  width: 400,
  height: 350,
  onChange: function onChange() {},
  onRemoveClick: function onRemoveClick() {},
  onLinkAdded: function onLinkAdded() {},
  index: 0,
  value: "",
  onedit: false
};
export default VideoItem;